import React, { useEffect, useState } from "react";
import { CiUser } from "react-icons/ci";
import axios from "axios";
import { TbCalendarTime } from "react-icons/tb";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import Utils from "../../utils/utils";
import { useToast } from "../ToastContext";
import { useAppLibs } from "../../ContextProvider/AppLib_Provider";
import ProgressBar from "./ProgressBar";
// import AssignmentGuide from "./AssignmentGuide";

const ProjectSubmissionView = ({ props }) => {
  const { item, index, editFormVisible, user } = props;
  const { Projects } = useAppLibs();

  const token = Utils.getToken();
  const SERVER_URL = `${process.env.REACT_APP_SERVER_URL}`;
  const [project, setProject] = useState(JSON.parse(JSON.stringify(item)));
  const [answer, setAnswer] = useState("");
  const [submission, setSubmission] = useState(null);
  const [newAnswer, setNewAnswer] = useState(submission?.submission || "");

  const [result, setResult] = useState(submission?.result || false);

  const [editingSubmission, setEditingSubmission] = useState(false);
  const [showGuide, setShowGuide] = useState(false);
  const showToast = useToast();
  const [submitting, setSubmitting] = useState(false);

  const handleAnsInputChange = (id, value) => {};

  const FetchSubmission = async (projectId) => {
    try {
      const result = await Projects.getSubmission(projectId);
      if (result.success) {
        const response = result.data;
        if (response) {
          setSubmission(response);
          setNewAnswer((prev) => response.submission);
        }
      } else {
        showToast(result.error, "error", true, 4000);
      }
    } catch (error) {
      showToast("Something went wrong " + error.message, "error", true, 4000);
    }
  };

  const HandleAssignmentSubmit = async (e) => {
    e.preventDefault();

    const formData = {};
    formData["projectId"] = project._id;
    formData["studentId"] = user._id;
    formData["submittedAt"] = Utils.getCurrentTime();

    const isValid =
      answer && (answer.startsWith("http://") || answer.startsWith("https://"));
    if (!isValid) {
      showToast(
        "Please enter valid URLs for submission.",
        "warning",
        true,
        7000
      );
      return;
    }

    formData["submission"] = answer;
    setSubmitting(true);
    try {
      const result = await Projects.addSubmission(formData);
      if (result.success) {
        const response = result.data;
        showToast("Success", "success", true, 3000);
        setSubmission(response);
        setNewAnswer((prev) => response.submission);
      } else {
        showToast(result.error, "error", true, 4000);
      }
    } catch (error) {
      showToast("Something went wrong " + error.message, "error", true, 4000);
    } finally {
      setSubmitting(false);
    }
  };

  const HandleReSubmisssion = async (e) => {
    e.preventDefault();
    if (answer && newAnswer && answer === newAnswer) {
      showToast("No new changes found", "warning", true, 3000);
      return;
    }

    const isValid =
      newAnswer &&
      (newAnswer.startsWith("http://") || newAnswer.startsWith("https://"));

    if (!isValid) {
      showToast("Please input a valid url!", "warning", true, 3000);
      return;
    }
    const formData = {};
    formData["updatedAt"] = Utils.getCurrentTime();
    formData["submission"] = newAnswer;
    setSubmitting(true);
    try {
      const result = await Projects.resubmission(submission._id, formData);
      if (result.success) {
        const response = result.data;
        showToast("Success", "success", true, 3000);
        setSubmission(response);
        setNewAnswer((prev) => response.submission);
        setEditingSubmission(false);
      } else {
        showToast(result.error, "error", true, 4000);
      }
    } catch (error) {
      showToast("Something went wrong " + error.message, "error", true, 4000);
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    FetchSubmission(project._id);
  }, []);

  return (
    // <div bkl="ProjectSubmissionView" className="">
    //   <div
    //     className="w-[98%] mx-auto overflow-x-hidden overflow-y-auto bg-white p-4 rounded-l-lg"
    //     style={{
    //       WebkitOverflowScrolling: "touch", // For smooth scrolling on iOS
    //       scrollbarWidth: "none", // Firefox
    //       msOverflowStyle: "none", // IE and Edge
    //     }}
    //   >

    //     <div className="p-6 space-y-4 shadow rounded-lg bg-white mb-4">
    //       <div className="bg-gray-50 p-3 mt-2">
    //         <h3 className="text-2xl font-semibold text-gray-700 truncate">
    //           {project.title}
    //         </h3>
    //       </div>

    //       <p className="text-gray-600 text-md">
    //         <span className="font-medium">Description: </span>
    //         {project.description}
    //       </p>

    //       {project.instruction && (
    //         <p className="text-gray-500 text-md italic">
    //           <span className="font-medium">Instruction: </span>
    //           {project.instruction}
    //         </p>
    //       )}
    //     </div>
    //     <div className="p-6 space-y-4 shadow rounded-lg bg-white mb-4">
    //       <div>
    //         <p className=" text-xl font-semibold">Documents</p>
    //         {project?.docs.map((doc, i) => (
    //           <button
    //             className="text-blue-500 underline"
    //             onClick={(e) => {
    //               e.preventDefault();
    //               e.stopPropagation();
    //               window.open(doc.url, "_blank", "noopener,noreferrer");
    //             }}
    //           >
    //             {doc.name}
    //           </button>
    //         ))}
    //       </div>
    //     </div>

    //     <div className="p-6 space-y-6 bg-gray-50 rounded-md">
    //       <h1 className="text-2xl font-bold text-gray-800 mb-4">
    //         Project Submission
    //       </h1>

    //       <div className="p-6 border rounded-lg shadow-md bg-white space-y-4">
    //         <div className="flex justify-between items-center xs:flex-wrap xs:flex-row-reverse">
    //           <span className="text-sm font-semibold text-red-500 italic">
    //             **Please enter a submission url for the project.**
    //           </span>
    //           <span className="text-sm font-semibold text-blue-600">
    //             Max Marks :
    //             {project.maxMarks >= 0 ? " " + project.maxMarks : " N/A"}
    //           </span>
    //         </div>

    //         {submission?.submission ? (
    //           <div>
    //             <div>
    //               <label
    //                 htmlFor={"submission"}
    //                 className="block text-sm font-semibold text-gray-600 mb-2"
    //               >
    //                 Submission URL:
    //               </label>
    //               <input
    //                 type="url"
    //                 name={"submission"}
    //                 value={newAnswer}
    //                 disabled={!editingSubmission}
    //                 onChange={(e) => {
    //                   const val = e.target.value || "";
    //                   setNewAnswer((prev) => val);
    //                 }}
    //                 className={`w-full px-4 py-2 text-sm text-gray-700 rounded-lg bg-gray-50 border focus:border-pink-700 focus:bg-white focus:outline-none
    //                      border-green-600
    //                   `}
    //                 placeholder="Enter submission URL"
    //               />
    //             </div>
    //             <div className="flex justify-end">
    //               {!editingSubmission ? (
    //                 <button
    //                   onClick={() => setEditingSubmission(true)}
    //                   className="mt-6 py-2 px-4 xs:py-1 xs:px-2 text-sm  text-blue-600 border border-blue-600 uppercase
    //             rounded-lg shadow hover:text-blue-800 hover:border-b-2 hover:shadow-xl hover:tracking-[0.05rem] trasition-all duration-200"
    //                 >
    //                   Edit Submissions
    //                 </button>
    //               ) : (
    //                 <div className="flex gap-2">
    //                   <button
    //                     onClick={(e) => {
    //                       e.preventDefault();
    //                       e.stopPropagation();
    //                       if (!newAnswer)
    //                         setNewAnswer((prev) => submission.submission);
    //                       setEditingSubmission(false);
    //                     }}
    //                     className="mt-6 py-2 px-4 xs:py-1 xs:px-2 text-sm bg-white text-orange-600 border border-orange-600 uppercase
    //               rounded-lg shadow hover:text-orange-800 hover:border-b-2 hover:shadow-xl hover:tracking-[0.05rem] trasition-all duration-200"
    //                   >
    //                     Cancel
    //                   </button>
    //                   <button
    //                     disabled={!newAnswer || submitting}
    //                     onClick={HandleReSubmisssion}
    //                     className={`mt-6 py-2 px-4 xs:py-1 xs:px-2 text-sm uppercase rounded-lg shadow transition-all duration-200
    //                           ${
    //                             newAnswer
    //                               ? "bg-white text-green-600 border border-green-600 hover:text-green-800 hover:border-b-2 hover:shadow-xl hover:tracking-[0.05rem]"
    //                               : "bg-gray-200 text-gray-500 border border-gray-300 cursor-not-allowed opacity-50"
    //                           }
    //                         `}
    //                   >
    //                     Resubmit
    //                   </button>
    //                 </div>
    //               )}
    //             </div>
    //           </div>
    //         ) : (
    //           <div>
    //             <div>
    //               <label
    //                 htmlFor={"submission"}
    //                 className="block text-sm font-semibold text-gray-600 mb-2"
    //               >
    //                 Submission URL:
    //               </label>
    //               <input
    //                 type="url"
    //                 name={"submission"}
    //                 value={answer}
    //                 onChange={(e) => {
    //                   const val = e.target.value || "";
    //                   setAnswer((prev) => val);
    //                 }}
    //                 className={`w-full px-4 py-3 text-sm text-gray-700 rounded-lg bg-gray-50 border focus:border-pink-700 focus:bg-white focus:outline-none
    //                  border-green-600
    //                     `}
    //                 placeholder="Enter submission URL"
    //               />
    //             </div>
    //             <div className="flex justify-end pb-1">
    //               <button
    //                 onClick={HandleAssignmentSubmit}
    //                 disabled={!answer || submitting}
    //                 className={`mt-6 py-2 px-4 xs:py-1 xs:px-2 text-sm uppercase rounded-lg shadow
    //                     ${
    //                       !answer
    //                         ? "cursor-not-allowed bg-gray-200"
    //                         : "text-pink-800 border border-pink-800  hover:pink-800 hover:border-b-2 hover:shadow-xl hover:tracking-[0.05rem] trasition-all duration-200"
    //                     } `}
    //               >
    //                 Submit
    //               </button>
    //             </div>
    //           </div>
    //         )}
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <div className="h-full w-full">
      <div
        className="h-full w-full xs:w-[90%] xs:mx-auto overflow-y-auto px-4 xs:pr-0 xs:mr-auto pt-6 pb-4"
        style={{
          WebkitOverflowScrolling: "touch",
        }}
      >
        <div className="mx-auto space-y-4">
          {/* Project Details Card */}
          <div className="bg-white rounded-lg shadow">
            <div className="p-4 space-y-4">
              <div className="bg-gray-50 p-3">
                <h3 className="text-2xl font-semibold text-gray-700 truncate">
                  {project.title}
                </h3>
              </div>

              <p className="text-gray-600 text-md">
                <span className="font-medium">Description: </span>
                {project.description}
              </p>

              {project.instruction && (
                <p className="text-gray-500 text-md italic">
                  <span className="font-medium">Instruction: </span>
                  {project.instruction}
                </p>
              )}
            </div>
          </div>

          {/* Documents Card */}
          <div className="bg-white rounded-lg shadow">
            <div className="p-4">
              <p className="text-xl font-semibold mb-4">Documents</p>
              <div className="space-x-4">
                {project?.docs.map((doc, i) => (
                  <button
                    key={i}
                    className="text-blue-500 hover:text-blue-700 underline"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      window.open(doc.url, "_blank", "noopener,noreferrer");
                    }}
                  >
                    {doc.name}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Submission Section */}
          <div className="bg-gray-50 rounded-lg shadow">
            <div className="p-4">
              <h1 className="text-2xl font-bold text-gray-800 mb-6">
                Project Submission
              </h1>

              <div className="bg-white rounded-lg shadow-sm p-4 space-y-6">
                <div className="flex justify-between items-center flex-wrap gap-2">
                  <span className="text-sm font-semibold text-red-500 italic">
                    **Please enter a submission url for the project.**
                  </span>
                  <span className="text-sm font-semibold text-blue-600">
                    Max Marks:
                    {project.maxMarks >= 0 ? ` ${project.maxMarks}` : " N/A"}
                  </span>
                </div>

                {submission?.submission ? (
                  <div className="space-y-4">
                    <div>
                      <label
                        htmlFor="submission"
                        className="block text-sm font-semibold text-gray-600 mb-2"
                      >
                        Submission URL:
                      </label>
                      <input
                        type="url"
                        id="submission"
                        name="submission"
                        value={newAnswer}
                        disabled={!editingSubmission}
                        onChange={(e) => setNewAnswer(e.target.value || "")}
                        className={`w-full px-4 py-2 text-sm text-gray-700 rounded-lg bg-gray-50 border border-green-600 focus:border-pink-700 focus:bg-white focus:outline-none`}
                        placeholder="Enter submission URL"
                      />
                    </div>
                    <div className="flex justify-end gap-2">
                      {!editingSubmission ? (
                        <button
                          onClick={() => setEditingSubmission(true)}
                          className="py-2 px-4 text-sm text-blue-600 border border-blue-600 rounded-lg hover:text-blue-800 hover:border-b-2 hover:shadow transition-all duration-200"
                        >
                          Edit Submission
                        </button>
                      ) : (
                        <>
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              if (!newAnswer)
                                setNewAnswer(submission.submission);
                              setEditingSubmission(false);
                            }}
                            className="py-2 px-4 text-sm text-orange-600 border border-orange-600 rounded-lg hover:text-orange-800 hover:border-b-2 hover:shadow transition-all duration-200"
                          >
                            Cancel
                          </button>
                          <button
                            disabled={!newAnswer || submitting}
                            onClick={HandleReSubmisssion}
                            className={`py-2 px-4 text-sm rounded-lg transition-all duration-200 ${
                              newAnswer
                                ? "text-green-600 border border-green-600 hover:text-green-800 hover:border-b-2 hover:shadow"
                                : "bg-gray-200 text-gray-500 border border-gray-300 cursor-not-allowed opacity-50"
                            }`}
                          >
                            Resubmit
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="space-y-4">
                    <div>
                      <label
                        htmlFor="submission"
                        className="block text-sm font-semibold text-gray-600 mb-2"
                      >
                        Submission URL:
                      </label>
                      <input
                        type="url"
                        id="submission"
                        name="submission"
                        value={answer}
                        onChange={(e) => setAnswer(e.target.value || "")}
                        className="w-full px-4 py-3 text-sm text-gray-700 rounded-lg bg-gray-50 border border-green-600 focus:border-pink-700 focus:bg-white focus:outline-none"
                        placeholder="Enter submission URL"
                      />
                    </div>
                    <div className="flex justify-end">
                      <button
                        onClick={HandleAssignmentSubmit}
                        disabled={!answer || submitting}
                        className={`py-2 px-4 text-sm rounded-lg transition-all duration-200 ${
                          !answer
                            ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                            : "text-pink-800 border border-pink-800 hover:border-b-2 hover:shadow"
                        }`}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div>
            {submission?.assessed && (
              <div className="p-6 border rounded-lg shadow-md bg-white space-y-4">
                <div className="flex  justify-between items-center xs:flex-col xs:items-start rounded-lg">
                  <div className="text-sm font-semibold text-blue-600">
                    Marks:{" "}
                    {submission.totalMarksObtained >= 0
                      ? submission.totalMarksObtained
                      : "N/A"}
                  </div>
                  <div className="w-1/2 mt-2 xs:mt-4 xs:w-full">
                    {project?.maxMarks &&
                      submission?.totalMarksObtained !== undefined && (
                        <ProgressBar
                          props={{
                            maxMarks: project.maxMarks,
                            totalMarksObtained: submission.totalMarksObtained,
                          }}
                        />
                      )}
                  </div>
                </div>
                <p className="text-gray-600 text-md">
                  <span className="font-medium">Feedback : </span>
                  {submission.feedback ? submission.feedback : "-"}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectSubmissionView;
